import { UrlResolver } from "../../util/UrlResolver";


export async function validateSession(urlKey: string, custKey: string): Promise<any> {
    const prefix = UrlResolver.resolveContextRouterUrl();
    const URI = `https://${prefix}.amfam.com/v1/validate`;

  
    var myHeaders = new Headers();
    myHeaders.append("accept", "application/json");
    myHeaders.append("cache-control", "no-cache");
    myHeaders.append("content-type", "application/j son");
    myHeaders.append("Authorization", "Bearer " + custKey);
    myHeaders.append("URLID", urlKey)
  
  
    return fetch(URI, {
      method: "GET",
      credentials: "include",
      headers: myHeaders,
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => console.log("Failed to retrieve contacts " + error));
  }